import { ResponseError } from '../../errors';
import { prepareSimilarNewobjects } from '../../mappers/prepareSimilarNewobjects';
import {
  fetchCianApiSiteV1GetNewobjectsBuilder as fetchGetNewobjectsBuilder,
  TCianApiSiteV1GetNewobjectsBuilderResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-newobjects-builder';
import { IApplicationContext } from '../../types/applicationContext';
import { ISimilarNewobject } from '../../types/similarNewobjects';

interface IParameters {
  newobjectId: number;
  subdomain?: string;
}

export async function fetchNewobjectsBuilder(
  context: IApplicationContext,
  parameters: IParameters,
): Promise<ISimilarNewobject[] | null> {
  const { httpApi, logger } = context;
  const { subdomain, newobjectId } = parameters;

  try {
    const newobjectsBuilderResponse: TCianApiSiteV1GetNewobjectsBuilderResponse = await fetchGetNewobjectsBuilder({
      httpApi,
      parameters: { newobjectId },
      config: subdomain ? { subdomain } : undefined,
    });

    if (newobjectsBuilderResponse.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchNewobjectsBuilder',
        message: newobjectsBuilderResponse.response.data?.message || '',
        details: { errors: JSON.stringify(newobjectsBuilderResponse.response.data?.errors) },
      });
    }

    return prepareSimilarNewobjects(newobjectsBuilderResponse.response);
  } catch (ex) {
    logger.warning(ex, {
      degradation: 'Similar newobjects from builder',
    });

    return null;
  }
}
